<script lang="ts">
</script>

<button on:click>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="100%"
		height="100%"
		viewBox="0 0 20 20">
		<g>
			<g>
				<path
					d="M260.549 98.2a.479.479 0 0 1-.339-.141.485.485 0 0 1 0-.683l18.89-19.037a.479.479 0 0 1 .68 0 .485.485 0 0 1 0 .683l-18.891 19.034a.477.477 0 0 1-.34.144z"
					transform="translate(-259.994 -78.197)" />
			</g>
			<g>
				<path
					d="M279.531 98.106a.482.482 0 0 1-.341-.14l-19.035-18.893a.482.482 0 1 1 .682-.681l19.034 18.893a.481.481 0 0 1-.341.821z"
					transform="translate(-260.013 -78.179)" />
			</g>
		</g>
	</svg>
</button>

<style lang="scss">
	@import "../../../variables.scss";
	button {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 20px;
		height: 20px;
		padding: 0;
		background-color: transparent;
		border: none;

		&:hover {
			cursor: pointer;
		}
	}
	svg {
		path {
			fill: #6d6f76;
			transition: fill 0.5s;
		}

		&:hover {
			fill: #7c7e86;
		}
	}

	@include DesktopSize {
		button {
			width: 25px;
			height: 25px;
		}
	}

</style>
